// Model "types" in the EEG Finetune Arena represent adapter / fine-tuning
// methods used with EEG foundation models (LaBraM, EEGPT, BIOT, BENDR,
// SignalJEPA, CBraMod, REVE).

export const MODEL_TYPE_ORDER = [
  'lora',
  'ia3',
  'adalora',
  'dora',
  'oft',
  'probe',
  'full_finetune'
];

export const MODEL_TYPES = {
  'lora': {
    icon: '',
    label: 'LoRA',
    description: 'Low-Rank Adaptation: injects trainable low-rank matrices into transformer layers (~98% parameter reduction)',
    order: 0
  },
  'ia3': {
    icon: '',
    label: 'IA3',
    description: 'Infused Adapter by Inhibiting and Amplifying Inner Activations (~99.5% parameter reduction)',
    order: 1
  },
  'adalora': {
    icon: '',
    label: 'AdaLoRA',
    description: 'Adaptive Low-Rank Adaptation with dynamic rank allocation across layers',
    order: 2
  },
  'dora': {
    icon: '',
    label: 'DoRA',
    description: 'Weight-Decomposed Low-Rank Adaptation: decomposes weights into magnitude and direction',
    order: 3
  },
  'oft': {
    icon: '',
    label: 'OFT',
    description: 'Orthogonal Fine-Tuning: applies orthogonal transformations to preserve pre-trained features',
    order: 4
  },
  'probe': {
    icon: '',
    label: 'Probe',
    description: 'Linear probing: freezes the encoder and trains only the classification head',
    order: 5
  },
  'full_finetune': {
    icon: '',
    label: 'Full Fine-tune',
    description: 'Full fine-tuning baseline: all model parameters are updated during training',
    order: 6
  }
};

export const getModelTypeIcon = (type) => {
  const cleanType = type.toLowerCase().trim();
  const matchedType = Object.entries(MODEL_TYPES).find(([key]) =>
    cleanType.includes(key)
  );
  return matchedType ? matchedType[1].icon : '';
};

export const getModelTypeLabel = (type) => {
  const cleanType = type.toLowerCase().trim();
  const matchedType = Object.entries(MODEL_TYPES).find(([key]) =>
    cleanType.includes(key)
  );
  return matchedType ? matchedType[1].label : type;
};

export const getModelTypeDescription = (type) => {
  const cleanType = type.toLowerCase().trim();
  const matchedType = Object.entries(MODEL_TYPES).find(([key]) =>
    cleanType.includes(key)
  );
  return matchedType ? matchedType[1].description : 'Unknown adapter method';
};

export const getModelTypeOrder = (type) => {
  const cleanType = type.toLowerCase().trim();
  const matchedType = Object.entries(MODEL_TYPES).find(([key]) =>
    cleanType.includes(key)
  );
  return matchedType ? matchedType[1].order : Infinity;
};

// OpenEEGBench submission options — fine-tuning strategies, heads, and the
// classification-only dataset set accepted by oeb.benchmark().
export const FINETUNING_STRATEGIES = [
  { value: "frozen", label: "Frozen (linear probing)" },
  { value: "ridge_probe", label: "Ridge probe" },
  { value: "lora", label: "LoRA" },
  { value: "ia3", label: "IA3" },
  { value: "adalora", label: "AdaLoRA" },
  { value: "dora", label: "DoRA" },
  { value: "oft", label: "OFT" },
  { value: "full_finetune", label: "Full fine-tune" },
  { value: "two_stages", label: "Two stages" },
];
export const HEADS = [
  { value: "linear_head", label: "Linear head" },
  { value: "mlp_head", label: "MLP head" },
  { value: "original_head", label: "Original head" },
];
export const PEFT_STRATEGIES = ["lora", "ia3", "adalora", "dora", "oft"];
export const OEB_DATASETS = [
  "bcic2a", "physionet", "bcic2020_3", "isruc_sleep", "tuab",
  "tuev", "mdd_mumtaz2016", "arithmetic_zyma2019", "faced", "seed_v",
];
